import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

// Dates are issue dates (PRD §9.4) formatted YYYY-MM-DD.
export const PERIOD_PRESETS = {
  TODAY: 'today',
  THIS_WEEK: 'this_week',
  LAST_WEEK: 'last_week',
  THIS_MONTH: 'this_month',
  LAST_MONTH: 'last_month',
  THIS_QUARTER: 'this_quarter',
  CUSTOM: 'custom',
};

export const PERIOD_PRESET_ORDER = [
  PERIOD_PRESETS.TODAY,
  PERIOD_PRESETS.THIS_WEEK,
  PERIOD_PRESETS.LAST_WEEK,
  PERIOD_PRESETS.THIS_MONTH,
  PERIOD_PRESETS.LAST_MONTH,
  PERIOD_PRESETS.THIS_QUARTER,
  PERIOD_PRESETS.CUSTOM,
];

export const CUSTOM_RANGE_MAX_MONTHS = 6;

const quarterStart = (d) => d.startOf('year').add(Math.floor(d.month() / 3) * 3, 'month');

// Returns {start, end} dayjs bounds, or null when the preset is custom.
export const getPeriodRange = (preset) => {
  const today = dayjs();
  switch (preset) {
    case PERIOD_PRESETS.TODAY:
      return { start: today.startOf('day'), end: today };
    case PERIOD_PRESETS.THIS_WEEK:
      return { start: today.startOf('isoWeek'), end: today };
    case PERIOD_PRESETS.LAST_WEEK: {
      const lastWeek = today.subtract(1, 'week');
      return { start: lastWeek.startOf('isoWeek'), end: lastWeek.endOf('isoWeek') };
    }
    case PERIOD_PRESETS.THIS_MONTH:
      return { start: today.startOf('month'), end: today };
    case PERIOD_PRESETS.LAST_MONTH: {
      const lastMonth = today.subtract(1, 'month');
      return { start: lastMonth.startOf('month'), end: lastMonth.endOf('month') };
    }
    case PERIOD_PRESETS.THIS_QUARTER:
      return { start: quarterStart(today), end: today };
    default:
      return null;
  }
};

export const isCustomRangeWithinLimit = (start, end) => {
  if (!start || !end) return true;
  return !end.isAfter(start.add(CUSTOM_RANGE_MAX_MONTHS, 'month'), 'day');
};
